var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.771,
    height: 18.771,
    viewBox: "0 0 18.771 18.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(-734.635 -145.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M17.6,3.9h-7.42v-1a1.531,1.531,0,0,0,.792-1.32A1.616,1.616,0,0,0,9.386,0,1.565,1.565,0,0,0,7.831,1.554a1.5,1.5,0,0,0,.792,1.32V3.9H1.173A1.158,1.158,0,0,0,0,5.074V17.6a1.217,1.217,0,0,0,1.173,1.173H17.6A1.217,1.217,0,0,0,18.771,17.6V5.1A1.222,1.222,0,0,0,17.6,3.9Zm-.381,13.316H1.554V9.386H17.187v7.831ZM1.554,7.831V5.485H17.187V7.831Z",
    transform: "translate(734.635 145.824)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M13.774,38.954h.792a.354.354,0,0,0,.381-.381v-.792a.354.354,0,0,0-.381-.381h-.792a.354.354,0,0,0-.381.381v.792A.354.354,0,0,0,13.774,38.954Z",
    transform: "translate(725.173 119.394)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M24.381,38.954h.792a.354.354,0,0,0,.381-.381v-.792a.354.354,0,0,0-.381-.381h-.792a.354.354,0,0,0-.381.381v.792A.37.37,0,0,0,24.381,38.954Z",
    transform: "translate(717.674 119.394)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M35.081,38.954h.792a.354.354,0,0,0,.381-.381v-.792a.354.354,0,0,0-.381-.381h-.792a.354.354,0,0,0-.381.381v.792A.37.37,0,0,0,35.081,38.954Z",
    transform: "translate(710.113 119.394)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M45.774,38.954h.792a.354.354,0,0,0,.381-.381v-.792a.354.354,0,0,0-.381-.381h-.792a.354.354,0,0,0-.381.381v.792A.354.354,0,0,0,45.774,38.954Z",
    transform: "translate(702.559 119.394)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M13.774,49.554h.792a.354.354,0,0,0,.381-.381v-.792A.354.354,0,0,0,14.565,48h-.792a.354.354,0,0,0-.381.381v.792C13.363,49.408,13.539,49.554,13.774,49.554Z",
    transform: "translate(725.173 111.903)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M24.381,49.554h.792a.354.354,0,0,0,.381-.381v-.792A.354.354,0,0,0,25.173,48h-.792a.354.354,0,0,0-.381.381v.792A.354.354,0,0,0,24.381,49.554Z",
    transform: "translate(717.674 111.903)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M35.081,49.554h.792a.354.354,0,0,0,.381-.381v-.792A.354.354,0,0,0,35.873,48h-.792a.354.354,0,0,0-.381.381v.792A.354.354,0,0,0,35.081,49.554Z",
    transform: "translate(710.113 111.903)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M45.774,49.554h.792a.354.354,0,0,0,.381-.381v-.792A.354.354,0,0,0,46.565,48h-.792a.354.354,0,0,0-.381.381v.792C45.363,49.408,45.539,49.554,45.774,49.554Z",
    transform: "translate(702.559 111.903)",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderDarkIcon);
export default __webpack_public_path__ + "static/media/CalenderDarkIcon.5e509f1ca0ad9ac46475bee7cec31d8f.svg";
export { ForwardRef as ReactComponent };